import angular from 'angular';
import { dateOffsetInterceptor } from './dateOffsetInterceptor';

angular.module('sh.dateOffset', []).config($httpProvider => {
	'ngInject';
	$httpProvider.interceptors.push(dateOffsetInterceptor);
});
